/**
 * Leest de waarde van een specifieke cookie.
 * 
 * @param name De naam van de cookie.
 * @returns De waarde van de cookie of null als deze niet gevonden is.
 */
export const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') {
    // Voorkom fouten bij server-side rendering of in andere omgevingen
    return null;
  }
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

/**
 * Verwijdert een specifieke cookie door de vervaldatum in het verleden te zetten.
 * 
 * @param name De naam van de cookie die verwijderd moet worden.
 * @param path Het pad van de cookie (standaard '/').
 * @param domain Het domein van de cookie (standaard het huidige domein).
 */
export const deleteCookie = (name: string, path: string = '/', domain?: string): void => {
  if (typeof document === 'undefined') {
    return;
  }
  let cookieString = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=" + path;
  if (domain) {
    cookieString += "; domain=" + domain;
  }
  document.cookie = cookieString;
  
  // Probeer ook te verwijderen zonder domein specifiek voor het geval het zo gezet was
  if (domain) {
      document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=" + path;
  }
}; 